import { useEffect } from 'react';
const useCustomInterestRate = (customRate, setLocalInterestRate, setUseCustomRate) => {
  useEffect(() => {
    if (typeof customRate === 'number') {
      setLocalInterestRate(customRate);
      setUseCustomRate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customRate]);
};
export { useCustomInterestRate as default };
